<template>
  <div v-on-clickaway="closeSelector" class="relative">
    <button
      class="nav-action-item flex items-center gap-1 p-1 rounded-[5px] hover:bg-gray-100 transition-colors shrink-0 cursor-pointer outline-none border-0 bg-transparent"
      @click="toggleSelector"
    >
      <div class="flex items-center gap-[5px]">
        <img
          v-if="currentPriority"
          :src="priorityIcons[currentPriority]"
          class="w-4 h-4"
          alt=""
        />
        <span
          v-else
          class="material-symbols-outlined text-[16px] text-gray-600 leading-none"
        >
          flag
        </span>
        <span class="text-sm text-gray-600 leading-5 whitespace-nowrap">
          {{ priorityLabel }}
        </span>
      </div>
      <span
        class="material-symbols-outlined text-[16px] text-gray-600 leading-none"
      >
        expand_more
      </span>
    </button>
    <dropdown-panel
      v-if="isOpenSelector"
      :items="priorityOptions"
      :selected-items="[currentPriority]"
      selected-key="id"
      :searchable="false"
      @select="onSelectPriority"
    >
      <template #item="{ item }">
        <img :src="item.icon" class="w-6 h-6" alt="" />
        <span class="my-[3px]">{{ item.name }}</span>
      </template>
    </dropdown-panel>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { mixin as clickaway } from 'vue-clickaway';
import { CONVERSATION_PRIORITY } from 'shared/constants/messages';
import { CONVERSATION_EVENTS } from 'dashboard/helper/AnalyticsHelper/events.js';
import DropdownPanel from './DropdownPanel.vue';

import noneIcon from 'dashboard/assets/images/priority_icons/none.svg';
import highIcon from 'dashboard/assets/images/priority_icons/high.svg';
import lowIcon from 'dashboard/assets/images/priority_icons/low.svg';
import mediumIcon from 'dashboard/assets/images/priority_icons/medium.svg';
import urgentIcon from 'dashboard/assets/images/priority_icons/urgent.svg';

export default {
  components: { DropdownPanel },
  mixins: [clickaway],
  data() {
    return {
      isOpenSelector: false,
      priorityIcons: {
        [CONVERSATION_PRIORITY.HIGH]: highIcon,
        [CONVERSATION_PRIORITY.LOW]: lowIcon,
        [CONVERSATION_PRIORITY.MEDIUM]: mediumIcon,
        [CONVERSATION_PRIORITY.URGENT]: urgentIcon,
      },
      priorityOptions: [
        {
          id: null,
          name: this.$t('CONVERSATION.PRIORITY.OPTIONS.NONE'),
          icon: noneIcon,
        },
        {
          id: CONVERSATION_PRIORITY.LOW,
          name: this.$t('CONVERSATION.PRIORITY.OPTIONS.LOW'),
          icon: lowIcon,
        },
        {
          id: CONVERSATION_PRIORITY.MEDIUM,
          name: this.$t('CONVERSATION.PRIORITY.OPTIONS.MEDIUM'),
          icon: mediumIcon,
        },
        {
          id: CONVERSATION_PRIORITY.HIGH,
          name: this.$t('CONVERSATION.PRIORITY.OPTIONS.HIGH'),
          icon: highIcon,
        },
        {
          id: CONVERSATION_PRIORITY.URGENT,
          name: this.$t('CONVERSATION.PRIORITY.OPTIONS.URGENT'),
          icon: urgentIcon,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      currentChat: 'getSelectedChat',
    }),
    currentPriority() {
      return this.currentChat?.priority || null;
    },
    priorityLabel() {
      if (!this.currentPriority) return this.$t('CONVERSATION.PRIORITY.TITLE');
      return this.$t(
        `CONVERSATION.PRIORITY.OPTIONS.${this.currentPriority.toUpperCase()}`
      );
    },
  },
  methods: {
    toggleSelector() {
      this.isOpenSelector = !this.isOpenSelector;
    },
    closeSelector() {
      this.isOpenSelector = false;
    },
    onSelectPriority(option) {
      const conversationId = this.currentChat?.id;
      const oldValue = this.currentChat?.priority;
      const priority = option.id;
      this.$store.dispatch('setCurrentChatPriority', {
        priority,
        conversationId,
      });
      this.$store
        .dispatch('assignPriority', { conversationId, priority })
        .then(() => {
          this.$track(CONVERSATION_EVENTS.CHANGE_PRIORITY, {
            oldValue,
            newValue: priority,
            from: 'Conversation Sidebar',
          });
          this.showAlert(
            this.$t('CONVERSATION.PRIORITY.CHANGE_PRIORITY.SUCCESSFUL', {
              priority: option.name,
              conversationId,
            })
          );
        });
      this.closeSelector();
    },
  },
};
</script>
